import {useEffect} from "react"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import Success from "./success.svg"

import {useAnalytics} from "@indebted/analytics"

function GrantESIGNConsentSuccess({i18n, customerID}: {i18n; customerID?}) {
	const {track} = useAnalytics()

	useEffect(() => {
		track("GrantESIGNConsentSuccessViewed", {
			CustomerID: customerID,
		})
	}, [customerID, track])

	return (
		<div>
			<Grid
				container
				spacing={7}
				justifyContent="center"
				alignItems="center"
				direction="column"
				style={{padding: "32px 24px"}}
			>
				<Grid>
					<img src={Success} />
				</Grid>
				<Grid>
					<Typography variant="h4" style={{color: "#626392", fontWeight: 700}}>
						{i18n.SuccessHeading}
					</Typography>
				</Grid>
				<Grid style={{padding: "0 14px"}}>
					<Typography align="center">{i18n.SuccessMessage}</Typography>
				</Grid>
			</Grid>
		</div>
	)
}

export {GrantESIGNConsentSuccess}
